import compose from 'lodash/flowRight';
import orderBy from 'lodash/orderBy';
import { withProps, acceptProps } from 'vue-compose';

import dataView from '~lib/common/hoc/dataView';

import CaseProcedures from './CaseProcedures.vue';
import queries from '~lib/common/queries/Treatment';

const enhance = compose(
  dataView({ queries }),
  withProps({
    procedures: props => orderBy(
      props.data.filter(t => t.category === 'PROCEDURE' && !t.disableToggle),
      procedure => procedure.displayOrder,
    ),
  }),
  acceptProps(['data']),
);

export default enhance(CaseProcedures);
